module.exports = __webpack_public_path__ + "assets/img/preface.19f29a6f.jpg";